module.exports = __webpack_public_path__ + "static/img/1ddfbd7ca01884b6cbe7fc97d01b3af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MODE1-off.png
// module id = Oudd
// module chunks = 1